/* tslint:disable */
/* eslint-disable */
export enum StatusCode {
  None = 0,
  Ok = 1,
  Warn = 2,
  Fail = 3
}
